<template>
  <a
    class="back iconfont icon-back"
    :class="pointClass"
    href="javascript:;"
    @click="goToLastRoute"
    v-bind="$attrs"
    v-on="$listeners"
  ></a>
</template>

<script>
export default {
  name: 'Back',
  props: {
    route: {
      type: String,
      default: '-1'
    },
    disableRouteBack: {
      type: Boolean,
      default: false
    },
    pointClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    goToLastRoute(e) {
      this.disableRouteBack || this.$router.go(this.route);
    }
  }
};
</script>

<style lang="scss" scoped>
.back {
  display: inline-block;
  position: relative;
  font-size: 30px;
  font-weight: bold;
  color: var(--back-color);
}
</style>
